module.exports = __webpack_public_path__ + "static/img/yeswecan0022.933eba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0022.png
// module id = 588
// module chunks = 1